import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { isNil, isEmpty, omit } from 'lodash';
import { checkUser, checkUserLogged, getUser } from 'store/user/actions';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import {
  Select,
  Input,
  Row,
  Col,
  Table,
  Divider,
  Space,
  Tooltip,
  Form,
  Button
} from 'antd';
import { useForm } from 'antd/lib/form/Form';
import { ReactComponent as ArrowIcon } from '../../../assets/icons/dropdown-arrow.svg';
import { ReactComponent as ActionsIcon } from '../../../assets/icons/more_dots.svg';
import { ReactComponent as FilterIcon } from '../../../assets/icons/filter_lines.svg';
import { ReactComponent as FilterIconBold } from '../../../assets/icons/filter_lines_bold.svg';
import Popover from '@mui/material/Popover';
import ActionList from './components/ActionList';
import SearchComponent from '../page1/components/searchBarComponent/index.js';
import { getLocalString, localNames } from "utils/localisation.service";
import { getListOfApplications, updateAdminField, updateAdminTableField, updateApplication } from 'store/adminPanel/actions';
import { FormField } from 'components';
import NoResults from 'pages/appTrack/page1/components/NoResults';

const Page1 = ({ disabled }) => {
  useEffect(() => {
    const initialPayload = {
      parameterList: [],
    };

    setDetailedPayload(initialPayload);
  }, []);

  const navigate = useNavigate();
  const viewMode = false;
  const [form] = useForm();
  const dispatch = useDispatch();
  const [response, setResponse] = useState([]);
  const [noData, setNoData] = useState(true);
  const [requiredFieldsError, setRequiredFieldsError] = useState(true);
  const [showEdit, setShowEdit] = useState(false);
  const [showView, setShowView] = useState(false);
  const [selectedProcId, setSelectedProcId] = useState();
  const [userCheck, setUserCheck] = useState(false);
  const [current, setCurrent] = useState(0);
  const [isFiltersVisible, setFiltersVisible] = useState(false);
  const [filterImg, setFilterImg] = useState(<FilterIcon/>);
  const userStatus = useSelector(state => state.user.status);
  const role = useSelector(state => state.user.userRole);
  const [isSideMenuVisible, setIsSideMenuVisible] = useState(true);
  const [detailedPayload, setDetailedPayload] = useState([]);
  const [refreshResults, setRefreshResults] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [open, setOpen] = useState(Boolean(anchorEl));
  const { Option } = Select;
  const locales = useSelector(state=> state.forms?.localeStrings);
  const carrier = useSelector(state => state.forms.carrier);
  const isViewMode = viewMode;
  const results = useSelector(state => state.adminPanel.variables);
  const processVariablesObj = useSelector(state => state.adminPanel.processVariables);
  const processVariables = processVariablesObj && Object.keys(processVariablesObj).map(key => ({
    id: key,
    ...processVariablesObj[key]
  }));

  const toggleSideMenu = () => {setIsSideMenuVisible(!isSideMenuVisible)};

  const dateFormat = 'DD/MM/YYYY';

  const renderTitle = title => <span>{title}</span>;

  const renderItem = title => ({
    value: title,
    label: (
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        {title}
      </div>
    ),
  });

  useEffect(()=> {
    const initialPayload = 
      {
        "parameterList":[]
      };
      
      setDetailedPayload(initialPayload);

  }, [])

  useEffect(() => {
    if (!isEmpty(detailedPayload) && userStatus)
      dispatch(getListOfApplications(detailedPayload))
  }, [detailedPayload]);

  useEffect(() => {
    dispatch(
      checkUserLogged(
        navigate,
        callback => {
          if(callback){
            dispatch(getUser());
          }
        }
      ),
    );
  }, []);

  useEffect(() => {
    const intervalId = setInterval(() => {
        dispatch(checkUser(navigate));
    }, process.env.REACT_APP_SESSION_CHECK_TIME);
    return () => clearInterval(intervalId);
  }, []);

  const toggleFilters = () => {
    setFiltersVisible(!isFiltersVisible);
  };

  useEffect(() => {
    // console.log("isFiltersVisible sto toggle",isFiltersVisible);
    if (isFiltersVisible) {
      setFilterImg(<FilterIconBold/>);
    } else {
      setFilterImg(<FilterIcon/>);
    }
  }, [isFiltersVisible]);

  const overFilter = () => {
    setFilterImg(<FilterIconBold/>);
  };

  const outFilter = () => {
    if (isFiltersVisible) {
      setFilterImg(<FilterIconBold/>);
    } else {
      setFilterImg(<FilterIcon/>);
    }
  };

  const filterText = isFiltersVisible ? "filterText" : "filterTextDefault";

  const onEmployeeNumberChange = value => {
    // console.log('BEFORE', value, detailedPayload);
    const detailedPayloadTmp = JSON.parse(JSON.stringify(detailedPayload));

    if (!isNil(value)) {
      if (
        detailedPayloadTmp.parameterList
          .map(i => i.qualifier.includes('EMPLOYEE_NUMBER'))
          .includes(true)
      ) {
        const filteredList = detailedPayloadTmp.parameterList.map(obj => {
          if (obj.qualifier === 'EMPLOYEE_NUMBER') {
            return { ...obj, value: value };
          } else {
            return { ...obj };
          }
        });

        const parameterList = {
          parameterList: filteredList,
        };
        setDetailedPayload(parameterList);
      } else {
        detailedPayloadTmp.parameterList.push({
          qualifier: 'EMPLOYEE_NUMBER',
          type: 'STRING_VALUE',
          value: value,
        });
        setDetailedPayload(detailedPayloadTmp);
      }
    } else {
      const filteredList = detailedPayloadTmp.parameterList.filter(
        i => i.qualifier !== 'EMPLOYEE_NUMBER'
      );
      const parameterList = {
        parameterList: filteredList,
      };
      setDetailedPayload(parameterList);
    }
  };

  const onEmployeeNameChange = value => {
    // console.log('BEFORE', value, detailedPayload);
    const detailedPayloadTmp = JSON.parse(JSON.stringify(detailedPayload));

    if (!isNil(value)) {
      if (
        detailedPayloadTmp.parameterList
          .map(i => i.qualifier.includes('employeeName'))
          .includes(true)
      ) {
        const filteredList = detailedPayloadTmp.parameterList.map(obj => {
          if (obj.qualifier === 'employeeName') {
            return { ...obj, value: value };
          } else {
            return { ...obj };
          }
        });

        const parameterList = {
          parameterList: filteredList,
        };
        setDetailedPayload(parameterList);
      } else {
        detailedPayloadTmp.parameterList.push({
          qualifier: 'employeeName',
          type: 'STRING_VALUE',
          value: value,
        });
        setDetailedPayload(detailedPayloadTmp);
      }
    } else {
      const filteredList = detailedPayloadTmp.parameterList.filter(
        i => i.qualifier !== 'employeeName'
      );
      const parameterList = {
        parameterList: filteredList,
      };
      setDetailedPayload(parameterList);
    }
  };

  const id = open ? 'simple-popover' : 'simple-popover';

  useEffect(() => {
    // console.log('Checking User');
    if (userStatus === 200) {
      setUserCheck(true);
    } else {
      setUserCheck(false);
    }
  }, [userStatus]);

  const onMoreClick = (id, b_key) => event => {
    setSelectedProcId(id);
    // setSelectedBusinessKey(b_key);
    // setSelectedBusKey(b_key);
    setAnchorEl(event.currentTarget);
    setOpen(true);
    // setUsers([]);
    // setSelectedUser(null);
    // setAssignDisabled(false);
  };

  const handleClose = () => {
    setOpen(false);
    setAnchorEl(null);
  };

  const renderFieldValue = field => {
    const value = processVariables.filter(i => i.name == field.name)[0].value;
    return field.type === 'date' ? (value ? moment(value) : '') : value;
  };

  const handleChange = ({ key, type, index, event }) => {
    let newValue;
    if (type === 'text' || type === 'string' || type === 'null' || type === 'textarea' || type === 'radio' || type === 'boolean') {
      newValue = event.target.value;
    } else if (type === 'date') {
      newValue = new Date(event).toLocaleDateString("en-US");
    } else if (type === 'checkbox') {
      newValue = event.target.checked;
    } else if (
      type === 'select' ||
      type === 'number' ||
      type === 'formattedNumber'
    ) {
      newValue = event;
    }

    dispatch(
      updateAdminField({
        group: 'processVariables',
        key: index,
        value: newValue,
      })
    );
  };

  const handleChangeTable = ({ key, type, index, event, parent, parent_index }) => {
    let newValue;
    if (type === 'text' || type === 'string' || type === 'null' || type === 'textarea' || type === 'radio' || type === 'boolean') {
      newValue = event.target.value;
    } else if (type === 'date') {
      newValue = new Date(event).toLocaleDateString("en-US");
    } else if (type === 'checkbox') {
      newValue = event.target.checked;
    } else if (
      type === 'select' ||
      type === 'number' ||
      type === 'formattedNumber'
    ) {
      newValue = event;
    }
    const otinane = processVariables.filter(b => b.name === parent)

    dispatch(
      updateAdminTableField({
        group: 'processVariables',
        key: key,
        value: newValue,
        index: index,
        parent: parent,
        parent_index: parent_index
      })
    );
  };


  // Application columns
  const columns = [
    {
      title: 'Process Definition ID',
      dataIndex: 'processDefinitionId',
      key: '1',
      width: "180px"
    },
    {
      title: 'Process Instance ID',
      dataIndex: 'id',
      key: '2',
      width: "180px"
    },
    {
      title: 'Business Key',
      dataIndex: 'businessKey',
      key: '3',
    },
    {
      title: 'Owner',
      dataIndex: 'owner',
      key: '4',
    },
    {
      title: 'Current Assignee',
      dataIndex: 'activeTaskAssignee',
      key: '5',
    },
    {
      title: 'Active Task Name',
      dataIndex: 'activeTaskName',
      key: '6',
    },
    {
      title: '',
      fixed: 'right',
      key: 'action',
      align: 'right',
      render: (text, record) => (
        <Space align="end" style={{ width: 'auto', marginRight: '2rem' }}>
          <Tooltip title="Actions">
            <ActionsIcon
              aria-describedby={id}
              onClick={e => onMoreClick(record.id, record.businessKey)(e)}
              style={{ cursor: 'pointer' }}
            />
          </Tooltip>
        </Space>
      ),
    },
  ];

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const rowSelection = {
    selectedRowKeys,
    onChange: (selectedKeys, selectedRows) => {
      setSelectedRowKeys(selectedKeys);
    },
  };
  useEffect(() => {
    const transformedFields = {};

    processVariables && processVariables.forEach(b => {
      b.type !== "serializable" && (
       transformedFields[b.name] = b.value);
    });

    form.setFieldsValue(transformedFields);

  }, [form, processVariables]);

  return (
    <div>
      {userCheck && (
        <div>
          <div>
            <Popover
              id={id}
              open={open}
              anchorEl={anchorEl}
              onClose={handleClose}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
              }}
            >
              <ActionList showEdit={setShowEdit} showView={setShowView} open={setOpen} id={selectedProcId} payload={detailedPayload} />
            </Popover>
          </div>
          <div className="">
          <div style={{ marginTop: '30px', marginBottom: '21px' }}>
          <SearchComponent className={`search-bar ${isSideMenuVisible ? 'shrunk' : ''}`} />
          <Tooltip placement="right" title="Expanded Filters">
            <Space onClick={() => toggleFilters()} onMouseEnter={() => overFilter()} onMouseLeave={() => outFilter()} className="filterButton mt-3">
              {filterImg}
              <span className={filterText}>{getLocalString(locales,localNames.HOME_PAGE_FILTERSBUTTON)}</span>
            </Space>
          </Tooltip>
          {isFiltersVisible &&
            <div className="filtersContainer">
              <div className="filters-wrapper">
                <div style={{ flex: '1' }}>
                  <Select
                    suffixIcon={<ArrowIcon />}
                    className="input-filter"
                    style={{ width: '100%' }}
                    dropdownAlign={{ offset: [-11, 5] }}
                    showSearch
                    allowClear={true}
                    placeholder="Process Definition ID"
                    optionFilterProp="children"
                    // defaultValue={detailedPayload.ministry}
                    onChange={onEmployeeNumberChange}
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    //filterSort={(optionA, optionB) => optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())}
                  >
                    {results?.map(item => (
                      <Option key={item.key} value={item.processDefinitionId}>
                        {item.processDefinitionId}
                      </Option>
                    ))}
                  </Select>
                </div>
                <div style={{ flex: '1' }}>
                  <Select
                    suffixIcon={<ArrowIcon />}
                    className="input-filter"
                    style={{ width: '100%' }}
                    dropdownAlign={{ offset: [-11, 5] }}
                    showSearch
                    allowClear={true}
                    placeholder="Process Instance ID"
                    optionFilterProp="children"
                    // defaultValue={
                    //   Array.isArray(detailedPayload.status)
                    //     ? detailedPayload.status.join(",")
                    //     : detailedPayload.status
                    // }
                    onChange={onEmployeeNameChange}
                    // filterOption={(input, option) =>
                    //   option.children
                    //     .toLowerCase()
                    //     .indexOf(input.toLowerCase()) >= 0
                    // }
                    //filterSort={(optionA, optionB) => optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())}
                  >
                    {results?.map(item => (
                      <Option key={item.key} value={item.id}>
                        {item.id}
                      </Option>
                    ))}
                  </Select>
                </div>
                <div style={{ flex: '1' }}>
                  <Select
                    suffixIcon={<ArrowIcon />}
                    className="input-filter"
                    style={{ width: '100%' }}
                    dropdownAlign={{ offset: [-11, 5] }}
                    showSearch
                    allowClear={true}
                    placeholder="Business Key"
                    optionFilterProp="children"
                    // defaultValue={detailedPayload.ministry}
                    // onChange={onMinistryChange}
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    //filterSort={(optionA, optionB) => optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())}
                  >
                    {results?.map(item => (
                      <Option key={item.key} value={item.businessKey}>
                        {item.businessKey}
                      </Option>
                    ))}
                  </Select>
                </div>
              </div>
              <div className="filters-wrapper">
                <div style={{ flex: '1' }}>
                  <Select
                    suffixIcon={<ArrowIcon />}
                    className="input-filter"
                    style={{ width: '100%' }}
                    dropdownAlign={{ offset: [-11, 5] }}
                    showSearch
                    allowClear={true}
                    placeholder="Owner"
                    optionFilterProp="children"
                    // defaultValue={detailedPayload.ministry}
                    // onChange={onMinistryChange}
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    //filterSort={(optionA, optionB) => optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())}
                  >
                    {results?.map(item => (
                      <Option key={item.key} value={item.owner}>
                        {item.owner}
                      </Option>
                    ))}
                  </Select>
                </div>
                <div style={{ flex: '1' }}>
                  <Select
                    suffixIcon={<ArrowIcon />}
                    className="input-filter"
                    style={{ width: '100%' }}
                    dropdownAlign={{ offset: [-11, 5] }}
                    showSearch
                    allowClear={true}
                    placeholder="Current Assignee"
                    optionFilterProp="children"
                    // defaultValue={
                    //   Array.isArray(detailedPayload.status)
                    //     ? detailedPayload.status.join(",")
                    //     : detailedPayload.status
                    // }
                    // onChange={onStatusChange}
                    // filterOption={(input, option) =>
                    //   option.children
                    //     .toLowerCase()
                    //     .indexOf(input.toLowerCase()) >= 0
                    // }
                    //filterSort={(optionA, optionB) => optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())}
                  >
                    {results?.map(item => (
                      <Option key={item.key} value={item.activeTaskAssignee}>
                        {item.activeTaskAssignee}
                      </Option>
                    ))}
                  </Select>
                </div>
                <div style={{ flex: '1' }}>
                  <Select
                    suffixIcon={<ArrowIcon />}
                    className="input-filter"
                    style={{ width: '100%' }}
                    dropdownAlign={{ offset: [-11, 5] }}
                    showSearch
                    allowClear={true}
                    placeholder="Active Task Name"
                    optionFilterProp="children"
                    // defaultValue={detailedPayload.ministry}
                    // onChange={onMinistryChange}
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    //filterSort={(optionA, optionB) => optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())}
                  >
                    {results?.map(item => (
                      <Option key={item.key} value={item.activeTaskName}>
                        {item.activeTaskName}
                      </Option>
                    ))}
                  </Select>
                </div>
              </div>
              <div className="filters-wrapper">
                <div style={{ flex: '1' }}></div>
                <div style={{ flex: '1' }}></div>
                <div style={{ flex: '1' }}></div>
              </div>
            </div>
            }

            <Divider className="filter-divider" />

            <Row gutter={32}>
              <Col span={24}>
                <div>
                  {/* <span className="results-label">{getLocalString(locales,localNames.ADMIN_PAGE_RESULTTABLE)}</span> */}

                  {!isEmpty(results) &&
                    <div>
                      {/* <span className="results-label">{getLocalString(locales,localNames.HOME_PAGE_RESULTTABLE)}</span> */}
                      <Table rowSelection={rowSelection} rowKey="key" scroll={{ x: true }} className="results-table" dataSource={results} columns={columns} pagination={{ showSizeChanger: false, showTitle: false }}></Table>
                    </div>
                  }
                  {isEmpty(results) && (
                    <NoResults 
                      description={'Δε βρέθηκαν αποτελέσματα'}
                      subDescription={'Παρακαλούμε ξανασυνδεθείτε με διαφορετικό Χρήστη.'}
                    />
                  )}                
                </div>
              </Col>
            </Row>
            {(showEdit || showView) &&
            <Row type="flex" justify="center" align="middle" gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
              <Col span ={16}>
              <Form
                form={form}
                initialValues={{
                  ...carrier,
                }}
                trigger="onChange"
              >
                <div
                  className=""
                >
                  <Row
                    gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
                    className=""
                  >
                    {processVariables && processVariables.map((field, index) => {
                      return (
                        <>
                      {field.type === "serializable" ?
                         <Col key={index} className="gutter-row" span={24}>
                             <div className='admin-label'>{field.name}</div>
                             <Table
                              className="results-table"
                              dataSource={field.value}
                              columns={Object.keys(!isEmpty(field.value) && field.value[0]).map(key => ({
                                title: key,
                                dataIndex: key,
                                editable: true,
                                render: (text, record, i) => {
                                  const editable = showEdit;
                                  return editable ? (
                                    <Form.Item
                                      // rules={field.rules}
                                      // value={renderFieldValue(field)}
                                      value={text}
                                      validateFirst
                                    >
                                      <Input
                                        key={i}
                                        value={text}
                                        onChange={value =>
                                          handleChangeTable({
                                            key: key,
                                            type: "string",
                                            index: i,
                                            event: value,
                                            parent: field.name,
                                            parent_index: index
                                          })
                                        }
                                      />
                                    </Form.Item>
                                  ) : (
                                    text
                                  );
                                },
                              }))}
                              rowClassName="editable-row"
                              // pagination={{ showSizeChanger: false, showTitle: false }}
                            />
                            {/* { 
                              field.value.map((tableField, ind) => {
                                return (
                                  <>
                                  <tr></tr>
                                  {Object.entries(tableField).map((item, i) => (
                                  // <td className='mb-1' key={i}>{item[0]} {item[1]}</td>
                                  <Form.Item
                                    name={[item[0]]}
                                    // rules={field.rules}
                                    // value={renderFieldValue(field)}
                                    value={item[1]}
                                    validateFirst
                                  >
                                    <FormField
                                      // key={i}
                                      label={<div className='admin-label'>{item[0]}</div>}
                                      disabled={field.disabled || showView}
                                      value={item[1]}
                                      options= {[
                                        { label: 'true', value: true, disabled: false },
                                        { label: 'false', value: false, disabled: false }
                                      ]}
                                      {...omit(field, ['span', 'rules', 'offset', 'disabled'])}
                                      
                                      onChange={value =>
                                        handleChangeTable({
                                          key: field.name,
                                          type: field.type,
                                          index: index,
                                          event: value,
                                        })
                                      }
                                    />
                                  </Form.Item>
                                ))}
                                </>)
                              })
                            } */}
                          </Col>
                        
                        : 
                        <Col key={index} className="gutter-row" span={12}>
                          <Form.Item
                            name={[field.name]}
                            // rules={field.rules}
                            // value={renderFieldValue(field)}
                            value={field.value}
                            validateFirst
                          >
                            <FormField
                              key={index}
                              value={field.value}
                              label={<div className='admin-label'>{field.name}</div>}
                              disabled={field.disabled || showView}
                              options= {[
                                { label: 'true', value: true, disabled: false },
                                { label: 'false', value: false, disabled: false }
                              ]}
                              {...omit(field, ['span', 'rules', 'offset', 'disabled'])}
                              
                              onChange={value =>
                                handleChange({
                                  key: field.name,
                                  type: field.type,
                                  index: index,
                                  event: value,
                                })
                              }
                            />
                          </Form.Item>
                        </Col>
                         }
                        </>
                      );
                    })}
                  </Row>
                </div>
                
                </Form>
                {showEdit && (
                  <Button type="default" id="save-admin-button" className="saveButton" onClick={() => dispatch(updateApplication(processVariablesObj, selectedProcId))}>
                  <span>{getLocalString(locales,localNames.REQUEST_PAGE_SAVEBUTTON)}</span>
                </Button>
                )}
        
              </Col>
            </Row>
            }
          </div>
        </div>
      </div>
      )}
      {/* {!userCheck && (
        dispatch(checkUser(navigate))
      )} */}
    </div>
  );
};

export default Page1;
